export const formatDate = date =>
  new Date(date).toGMTString().split(/\s+/).slice(0, -2).join(' ');
